import { useState, useEffect } from "react"
// import NavBar from "@/component/navBar"
import ClassTypeMajor from "@/component/classTypeMajor"
import $api from "@/api/index"
function ClassType() {
  const [classList, setClassList] = useState([])

  const getCollegeList = async () => {
    const { result } = await $api.class.relation()
    setClassList(result || [])
  }

  useEffect(() => {
    getCollegeList()
  }, [])

  return (
    <div>
      {/* <NavBar hasSider={false} /> */}
      <h3 className="section__title">班型介绍</h3>
      <div className="section__inner">
        {classList && <ClassTypeMajor classList={classList} />}
      </div>
    </div>
  )
}

export default ClassType
